import React, { useContext, useState, useEffect } from 'react';
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Spinner from "react-bootstrap/Spinner";
import { 
  Text, BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, 
  Tooltip, LabelList, ResponsiveContainer } from 'recharts';

import quizInstanceAdminStatusContext from '../context/quizInstanceAdminStatusContext';
import QuizAdminQuestion from './QuizAdminQuestion';
import QuizApi from '../QuizApi';

export default function QuizAdminStatsPoll() {

  const ctx = useContext(quizInstanceAdminStatusContext);
  const [quizStats, setQuizStats] = useState(null);

  useEffect(() => 
  {
    const fn = async () => 
    {
      const statsResponse = await QuizApi.quizAdminGetStats(ctx.quizAccessId);
      setQuizStats(statsResponse.response);
    };

    fn();

  }, [ctx]);

  const primaryColors = ctx.quizStyle.colorList.map(c => c.primaryCss);
  const axisStyle = { fill: '#5C5D50' };

  const answerCountListsByQuestionId = {};
  if (quizStats && quizStats.answerHistogram) 
  {
    // ====================================================================
    // Construct the data needed to display a bar chart for each question
    // ====================================================================
    for (const question of ctx.quizInfo.questionList) 
    {
      const answerCountList = [];
      for (const answer of question.answerList)
      {
        const answerCount = quizStats.answerHistogram[answer.id];
        answerCountList.push({
          id: answer.id,
          name: answer.text,
          percent: Number(((answerCount || 0) / (ctx.quizInfo.participantAnsweredCount || 1) * 100).toFixed(0))
        });
      }

      answerCountListsByQuestionId[question.id] = answerCountList;
    }
  }

  return (
    <>
      {quizStats === null &&         
        <Container>
          <div className="d-flex justify-content-center align-items-center h-100">
            <Spinner animation="border" />
          </div>
        </Container>
      }
      {quizStats !== null && 
        <Container id="pollAdminStatsWrapper">
          <Row noGutters className="justify-center">
            <Col className="" style={{maxWidth: "970px" }}>
              <div className="mt-4">
                {ctx.quizInfo.questionList.map((question, qIdx) => 

                  <div className="mt-4">

                    <QuizAdminQuestion
                      key={question.id}
                      question={question}
                      questionNumber={qIdx + 1}
                      quizInfo={ctx.quizInfo}
                      color={ctx.quizStyle.colorList[qIdx % ctx.quizStyle.colorList.length]}
                      showAnswers={false}
                    />

                    <div style={{
                      width: "95%", 
                      height: `${105 * (answerCountListsByQuestionId[question.id] || []).length}px`
                    }}>

                      <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                          data={answerCountListsByQuestionId[question.id] || []}
                          margin={{ top: 20 }}
                          layout="vertical"
                          barSize={20}
                        >
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis
                            type="number"
                            domain={[0, 100]}
                            orientation='top'
                            label={
                              {
                                value: '% svar',
                                fill: '#5C5D50',
                                position: "center",
                                dy: -20
                              }
                            }
                          />
                          <YAxis
                            type="category"
                            width={30}
                            tick={false}
                          />
                          <Tooltip
                            cursor={false}
                            labelFormatter={() => ""}
                            formatter={(value, name, props) => [`${value}%`, "Antal svar"]}
                          />
                          <Bar 
                            cursor="pointer" 
                            dataKey="percent" 
                            // minPointSize={2} 
                          >
                            {
                              (answerCountListsByQuestionId[question.id] || []).map((entry, cellIdx) => (
                                <Cell key={`cell-${cellIdx}`} fill={primaryColors[qIdx % ctx.quizStyle.colorList.length]} />
                              ))
                            }

                            <LabelList
                              dataKey="name"
                              position="top"
                              content={({ x, y, width, value, index }) => {
                                const fillColor = primaryColors[qIdx % ctx.quizStyle.colorList.length];
                                return (
                                  <text
                                    x={x}
                                    y={y}
                                    dx={10}
                                    dy={-10}
                                    fill={fillColor}
                                    textAnchor="start"
                                    className='font-weight-bold'
                                  >
                                    {value}
                                  </text>
                                );
                              }}
                            />
                          </Bar>
                        </BarChart>
                      </ResponsiveContainer>
                    </div>

                  </div>
                )}

              </div>
            </Col>
          </Row>
        </Container>
      }
    </>
  );
};